import { render, staticRenderFns } from "./BattlesGameBoxes.vue?vue&type=template&id=b2f6300a&scoped=true"
import script from "./BattlesGameBoxes.vue?vue&type=script&lang=js"
export * from "./BattlesGameBoxes.vue?vue&type=script&lang=js"
import style0 from "./BattlesGameBoxes.vue?vue&type=style&index=0&id=b2f6300a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f6300a",
  null
  
)

export default component.exports